export type AUAExperimentCohort = 'not-enrolled' | 'control' | 'test';

export const AUTO_UPGRADE_AWARENESS_EXPERIMENT = 'confluence_auto_upgrade_awareness';
